<template>
  <div class="container">
    <img class="QRcode" v-if="QrCodeUrl" :src="QrCodeUrl" alt="" />
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import utils from "../../common/utils/utils";
import { mapState } from "vuex";
export default {
  name: 'MyQRcode',
  data() {
    return {
      data: null,
      QrCodeUrl: ''
    }
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    this.getQRcode();
    // this.hideShareMenu();
    this.toast = this.$toast.loading({
      message: '生成中...',
      forbidClick: true,
    });
  },
  methods: {
    getQRcode() {
      this.$axios.get('/Api/Api/web/Customer/GeneratePoster').then(res => {
        if (res.RetCode == '10000') {
          this.data = res.Data;
          this.QrCodeUrl = res.Data;
          this.toast.clear();
        } else {
          this.$toast(res.RetMsg);
        }
      })
    },
    hideShareMenu() {
      const entryLink = utils.getEntryLink();
      this.$axios.get("/Api/Api/web/WechatHelper/GetWechat?backUrl=" + entryLink).then(res => {
        wx.config({
          debug: false,
          appId: res.Data.AppId,
          timestamp: res.Data.TimesTamp,
          nonceStr: res.Data.NonceStr,
          signature: res.Data.She1Str,
          jsApiList: ["hideAllNonBaseMenuItem"],
        });
      })
      wx.checkJsApi({
        jsApiList: ["hideAllNonBaseMenuItem"],
        success: function() {
          wx.ready(() => {
            wx.hideAllNonBaseMenuItem();
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    text-align: center;
    .QRcode {
      display: block;
      width: 100%;
    }
  }
</style>